import { handleActions } from 'redux-actions';
import { SetShowSuggestionModal, setShowSuggestionModal, toggleShowSuggestionModal } from './actions';

const initialState = false;

const showSuggestionModalReducer = handleActions(
	{
		[setShowSuggestionModal.toString()]: (_, { payload }: SetShowSuggestionModal) => payload,
		[toggleShowSuggestionModal.toString()]: state => !state
	},
	initialState
);

export default showSuggestionModalReducer;
